import { Box } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { useCommentableTextAtoms, useCommentsDrawer } from '@/comments';
import { CommentsDrawer } from '@/components/CommentsDrawer/CommentsDrawer';
import { CreateCommentTooltip } from '@/components/CreateComment/CreateCommentTooltip';
import { Navigation } from '@/components/Navigation/Navigation';
import { Snackbars } from '@/components/Snackbar/Snackbar';
import { paths } from '@/constants';
import { useParkedNoteGesturesUnloadGuard } from '@/hooks/fountain/useParkedNoteGesturesUnloadGuard';
import { usePermissions } from '@/hooks/usePermissions';
import { useVersionGate } from '@/hooks/useReadOnlyGate';
import { useResumeImportSse } from '@/hooks/useResumeImportSse';
import { ModalHost } from '@/modals';

export const Layout = () => {
    const location = useLocation();
    const { isReadOnly } = useVersionGate();
    const { canReadComments } = usePermissions();
    const [drawer, drawerActions] = useCommentsDrawer();
    const { clear } = useCommentableTextAtoms();
    useResumeImportSse();
    useParkedNoteGesturesUnloadGuard();

    useEffect(() => {
        clear();
        drawerActions.hideTopInput();
    }, [clear, drawerActions]);

    const pathname = location.pathname.length > 1 ? location.pathname.replace(/\/$/, '') : location.pathname;
    const showDrawer =
        pathname !== paths.project.scene.editor && pathname !== paths.project.scene.editor_pep && pathname !== paths.concept.editor;

    return (
        <div className="flex w-full h-full flex-nowrap">
            <Navigation />
            <div className="flex flex-wrap w-full overflow-hidden relative">
                <Outlet />

                {!isReadOnly && canReadComments && showDrawer && (
                    <CommentsDrawer open={drawer.isOpen} onClose={() => drawerActions.close()} />
                )}

                <Box
                    id="scene-action-bar-slot"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        pointerEvents: 'none',
                        '& > *': { pointerEvents: 'auto' },
                    }}
                />
            </div>

            <CreateCommentTooltip />
            <Snackbars />
            <ModalHost />
        </div>
    );
};
